import { 
    Popup, 
    ToolbarItem,
} from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import { Button } from 'devextreme-react/button';
import {useRef, useState, useCallback, useEffect} from 'react'
import TextBox from 'devextreme-react/text-box';
import { httpRequest } from '../../functions';
import { useRequestsApi } from '../../Context/RequestsApi';
import { applicationID, relationId } from '../../api/ApplicationID';
import { Toast } from 'devextreme-react/toast';
import UpfHtmlEditor from '../UpfComponents/UpfHtmlEditor';
import UpfPopupMessage from '../../CardComponents/UpfPopupMessage';
import SelectBox from 'devextreme-react/select-box';
import { LoadPanel } from 'devextreme-react/load-panel';

const HtmlFormPopup = (props) => {
    const _htmlPopupRef = useRef(null)
    const {requestsApi} = useRequestsApi()

    const [editandoHtml, setEditandoHtml] = useState(false)

    const [htmlContent, setHtmlContent] = useState(false)
    const [htmlPermissionsState, setHtmlPermissionsState] = useState({})

    const [emailsState, setEmailsState] = useState([])
    const [emailSelecionadoState, setEmailSelecionadoState] = useState()

    const [telefonesState, setTelefonesState] = useState([])
    const [telefoneSelecionadoState, setTelefoneSelecionadoState] = useState()

    const [popupAskInsertNewEmailVisibleState, setPopupAskInsertNewEmailVisibleState] = useState(false)
    const [popupAskInsertNewTelefoneVisibleState, setPopupAskInsertNewTelefoneVisibleState] = useState(false)

    //---------LOADING------------//
    
        //Estados
        const loadingPanelOptions = {
            loadPanelVisible: false,
            showIndicator: true,
            shading: false,
            showPane: true,
            closeOnOutsideClick: false
        }
        const [loadingPanelState, setLoadingPanelState] = useState(loadingPanelOptions)
    
        //Funções
        const hideLoadPanel = useCallback(() => {
            setLoadingPanelState({
                ...loadingPanelState,
                loadPanelVisible: false,
            })
        }, [loadingPanelState])

        const showLoadPanel = useCallback(() => {
            setLoadingPanelState({
                ...loadingPanelState,
                loadPanelVisible: true,
            })
        }, [loadingPanelState])
    
        //---------LOADING------------//
    const getEmailsClienteIdFunction = () => {
        showLoadPanel()
        httpRequest('POST', requestsApi.getEmailsClienteId,  requestsApi.basicAuth,{
            "applicationId": applicationID,
            "relationId": relationId,
            "clienteId": props.clienteid,
        })
        .then((sender) => {
            hideLoadPanel()
            const resultGetEmailsClienteId = JSON.parse(sender)
            console.log(resultGetEmailsClienteId)
            setEmailsState(resultGetEmailsClienteId)
            if(!emailSelecionadoState){
                setEmailSelecionadoState(resultGetEmailsClienteId[0])
            }
        })
        .catch((error) => {
            hideLoadPanel()
            console.log(error?.data?.error)
            setPopupStates({
                visible: true,
                message: error?.data?.error
            })
        })
    }

    const getTelefonesClienteIdFunction = () => {
        showLoadPanel()
        httpRequest('POST', requestsApi.getDataEntity,  requestsApi.basicAuth,{
            "applicationId": applicationID,
            "entityName": "_cadastro_contatos",
            "relationId": relationId,
            "fieldName": "_cadastro_id",
            "expressao": props.clienteid,
        })
        .then((sender) => {
            hideLoadPanel()
            const resultGetTelefonesClienteId = JSON.parse(sender)?.masterEntity?.[0]?.records
            const arrayTelefones = []
            for(let c = 0; c <= resultGetTelefonesClienteId.length - 1; c++){
                arrayTelefones.push(resultGetTelefonesClienteId[c]?._cryptfone)
            }
            setTelefonesState(arrayTelefones)
            if(!telefoneSelecionadoState){
                setTelefoneSelecionadoState(arrayTelefones[0])
            }
        })
        .catch((error) => {
            hideLoadPanel()
            console.log(error?.data?.error)
            setPopupStates({
                visible: true,
                message: error?.data?.error
            })
        })
    }

    useEffect(() => {
        if(props.clienteid){
            getEmailsClienteIdFunction()
            getTelefonesClienteIdFunction()
        }

    }, [props.clienteid])

    const openPopupAskInsertNewEmail = useCallback(() => {
        setPopupAskInsertNewEmailVisibleState(true)
    }, [popupAskInsertNewEmailVisibleState])

    const closePopupAskInsertNewEmail = useCallback(() => {
        setPopupAskInsertNewEmailVisibleState(false)
    }, [popupAskInsertNewEmailVisibleState])


    const insertNewEmail = () => {
        closePopupAskInsertNewEmail()
        showLoadPanel()
        httpRequest("POST", requestsApi.insertRecordFromJson, requestsApi.basicAuth,
        {
            "entityName": "_cadastro_emails",
            "json": [{_cryptemail: emailSelecionadoState, _cadastro_id: props.clienteid}],
            "applicationId": applicationID,
            "relationId": relationId
        })
        .then((sender) => {
            getEmailsClienteIdFunction()
            // hideLoadPanel()
            // toastConfiguration(true, 'success', "Registro inserido com sucesso!")
        })
        .catch((error) => {
            hideLoadPanel()
            console.log(error?.data?.error)
            setPopupStates({
                visible: true,
                message: error?.data?.error ? error?.data?.error : 'E-mail inválido!'
            })
        })
    }

    const openPopupAskInsertNewTelefone = useCallback(() => {
        setPopupAskInsertNewEmailVisibleState(true)
    }, [popupAskInsertNewEmailVisibleState])

    const closePopupAskInsertNewTelefone = useCallback(() => {
        setPopupAskInsertNewEmailVisibleState(false)
    }, [popupAskInsertNewEmailVisibleState])

    const insertNewTelefone = () => {
        closePopupAskInsertNewEmail()
        showLoadPanel()
        httpRequest("POST", requestsApi.insertRecordFromJson, requestsApi.basicAuth,
        {
            "entityName": "_cadastro_contatos",
            "json": [{_cryptfone: telefoneSelecionadoState, _cadastro_id: props.clienteid}],
            "applicationId": applicationID,
            "relationId": relationId
        })
        .then((sender) => {
            getTelefonesClienteIdFunction()
            // hideLoadPanel()
            // toastConfiguration(true, 'success', "Registro inserido com sucesso!")
        })
        .catch((error) => {
            hideLoadPanel()
            console.log(error?.data?.error)
            setPopupStates({
                visible: true,
                message: error?.data?.error ? error?.data?.error : 'Telefone inválido!'
            })
        })
    }

    const closeButtonPopupAskInsertNewTelefone = {
        text:"Não"
        ,type: 'default'
        ,stylingMode: 'default' 
        // ,icon: "chevronleft"
        ,onClick: closePopupAskInsertNewTelefone
    }

    const confirmButtonPopupAskInsertNewTelefone = {
        text: "Sim"
        // ,icon: "color"
        ,type: 'default'
        ,stylingMode: 'default' 
        ,onClick: insertNewTelefone
    }

    

    const closeButtonPopupAskInsertNewEmail = {
        text:"Não"
        ,type: 'default'
        ,stylingMode: 'default' 
        // ,icon: "chevronleft"
        ,onClick: closePopupAskInsertNewEmail
    }

    const confirmButtonPopupAskInsertNewEmail = {
        text: "Sim"
        // ,icon: "color"
        ,type: 'default'
        ,stylingMode: 'default' 
        ,onClick: insertNewEmail
    }

    const checkSelectedEmailInEmailsExisting = () => {
        if(props.clienteid){
            if(!emailsState.find((e) => e === emailSelecionadoState)){
                openPopupAskInsertNewEmail()
            }
        }
    }

    const checkSelectedTelefoneInTelefoneExisting = () => {
        if(props.clienteid){
            if(!telefonesState.find((e) => e === telefoneSelecionadoState)){
                openPopupAskInsertNewTelefone()
            }
        }
    }

    

    useEffect(() => {
        console.log(props.htmlTemplate)
        if(props.htmlTemplate){
            if(!htmlContent){
                setHtmlContent(props.htmlTemplate)
                setHtmlPermissionsState({
                    isPermitirEditar: props.htmlTemplate?.resultJsonTemplateHtml?.isPermitirEditar,
                    isPermitirEnviarAssinatura: props.htmlTemplate?.resultJsonTemplateHtml?.isPermitirEnviarAssinatura,
                    isPermitirEnviarEmail: props.htmlTemplate?.resultJsonTemplateHtml?.isPermitirEnviarEmail,
                })
                // htmlPopupFunction()
            }
            else{
                _htmlPopupRef.current?.instance.repaint()
            }
        }

    }, [props.htmlTemplate, editandoHtml])

    // useEffect(() => {
    //     console.log(props)
    //     console.log(props.htmlTemplate)
    //     console.log(htmlContent)

    // }, [htmlContent])

    const [popupStates, setPopupStates] = useState({
        visible: false,
        message: null
    })

    const hidePopupMessage = () => {
        setPopupStates({
          ...popupStates,
          visible: false
        })
    }

    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: ""
    })

    const onHiding = () => {
        hideLoadPanel()
        setToastConfig({
            ...toastConfig,
            isVisible: false
        })
        props.setHtmlPopupVisible(false)

    }

    const toastConfiguration = useCallback((visible, type, message) => {
        setToastConfig({
            ...toastConfig,
            isVisible: visible,
            type: type,
            message: message
        });
    }, [toastConfig])


    const htmlPopupFunction = () => {
        _htmlPopupRef.current?.instance.beginUpdate()
        let content = document.getElementById("divcontents");
        let pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        _htmlPopupRef.current?.instance.endUpdate()
    }

    const onHidenPopupHtmlTemplate = () => {
        setHtmlContent(false)
        setHtmlPermissionsState({})
        props.setHtmlPopupVisible(false)
    }

    const mostrarHtml = () => {
        if(editandoHtml){
            let content = htmlContent?.__html;
            let pri = document.getElementById("ifmcontentstoprint").contentWindow;
            content = '<!DOCTYPE html><html lang="en">' + content
            pri.document.open();
            pri.document.write(content);
            pri.document.close();
            pri.focus();
            pri.print();
        }
        else{
            let content = document.getElementById("divcontents");
            let pri = document.getElementById("ifmcontentstoprint").contentWindow;
            content = '<!DOCTYPE html><html lang="en">' + content.innerHTML
            pri.document.open();
            pri.document.write(content);
            pri.document.close();
            pri.focus();
            pri.print();
        }
        // let content = document.getElementById("divcontents");
        //     let pri = document.getElementById("ifmcontentstoprint").contentWindow;
        //     pri.document.open();
        //     pri.document.write(content.innerHTML);
        //     pri.document.close();
        //     pri.focus();
        //     pri.print();
        
    }


    const renderHtmlFunction = () => {
        if(htmlContent){
            return htmlContent
        }
        else{
            return props.htmlTemplate
        }
    }

    const HtmlComponent = () => {
        return <div id="divcontents"  dangerouslySetInnerHTML={renderHtmlFunction()} />;
    }

    

    return(
        <Popup
            ref={_htmlPopupRef}
            visible={props.htmlPopupVisible && htmlContent}
            onHiding={onHidenPopupHtmlTemplate}
            dragEnabled={false}
            showCloseButton={true}
            showTitle={true}
            title=""
            fullScreen={true}
            hideOnOutsideClick={false}
            resizeEnabled={true}
            deferRendering={true}
            // onShown={mostrarHtml}
            // onShown={htmlPopupFunction}
        >
            <ScrollView width='100%' height='100%'>

                    <UpfPopupMessage
                        hidePopup={hidePopupMessage}
                        visible={popupStates.visible}
                        message={popupStates.message}
                    />

                    <Toast
                        visible={toastConfig.isVisible}
                        message={toastConfig.message}
                        type={toastConfig.type}
                        onHiding={onHiding}
                        displayTime={2500}
                        height={60}
                    />

                    <LoadPanel
                        style={{ zIndex: "-1 !important", border: "solid 1px red !important" }}
                        shadingColor="rgba(0,0,0,0.4)"
                        visible={loadingPanelState.loadPanelVisible}
                        // visible={true}
                        showIndicator={loadingPanelState.showIndicator}
                        shading={loadingPanelState.shading}
                        showPane={loadingPanelState.showPane}
                    />

                    <Popup
                        visible={popupAskInsertNewEmailVisibleState}
                        onHiding={closePopupAskInsertNewEmail}
                        dragEnabled={false}
                        showCloseButton={true}
                        showTitle={true}
                        fullScreen={false}
                        hideOnOutsideClick={false}
                        resizeEnabled={false}
                        deferRendering={true}
                        title="Atenção!"
                        width={600}
                        height={310}
                    >
                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="after"                  
                            options={confirmButtonPopupAskInsertNewEmail}
                        />

                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="after"
                            options={closeButtonPopupAskInsertNewEmail}
                        />
        
                        <p>
                            Deseja atualizar este e-mail no cadastro do cliente?
                        </p>

                    </Popup>

                    <Popup
                        visible={popupAskInsertNewTelefoneVisibleState}
                        onHiding={closePopupAskInsertNewTelefone}
                        dragEnabled={false}
                        showCloseButton={true}
                        showTitle={true}
                        fullScreen={false}
                        hideOnOutsideClick={false}
                        resizeEnabled={false}
                        deferRendering={true}
                        title="Atenção!"
                        width={600}
                        height={310}
                    >
                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="after"                  
                            options={confirmButtonPopupAskInsertNewTelefone}
                        />

                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="after"
                            options={closeButtonPopupAskInsertNewTelefone}
                        />
        
                        <p>
                            Deseja atualizar este telefone no cadastro do cliente?
                        </p>

                    </Popup>

                    <div>
                            <div style={{width: '100%', display: "flex", alignItems: "end", marginBottom: "1em"}}>
                                <Button
                                    text="Imprimir"
                                    onClick={mostrarHtml}
                                    type="default"
                                    icon="print"
                                />

                                {!editandoHtml &&
                                    <Button
                                        text="Editar"
                                        onClick={() => {
                                            setEditandoHtml(true)
                                        }}
                                        type="default"
                                        icon="edit"
                                        visible={htmlPermissionsState?.isPermitirEditar === 1}
                                        style={{marginLeft: '1em'}}
                                    />
                                }

                                {htmlPermissionsState?.isPermitirEnviarAssinatura === 1 || htmlPermissionsState?.isPermitirEnviarEmail === 1 ?
                                (
                                    <div style={{marginLeft: '1em', display: "flex", alignItems: "center", width: "60vw"}}>
                                        {htmlPermissionsState?.isPermitirEnviarEmail === 1 ? 
                                        (
                                            <>
                                                <div style={{marginRight: '1em'}}>
                                                    E-mail:
                                                </div>
                                                {emailsState?.length > 0 ? 
                                                    (
                                                        <SelectBox
                                                            style={{width: '30vw', marginRight: '1em'}}
                                                            dataSource={emailsState}
                                                            defaultValue={emailsState[0]}
                                                            onValueChanged={(item) => {
                                                                setEmailSelecionadoState(item.value)
                                                            }}
                                                            acceptCustomValue={true}
                                                            customItemCreateEvent={"focusout"}
                                                            searchTimeout={200}
                                                            minSearchLength={0}
                                                            showDataBeforeSearch={false}
                                                            showClearButton={true}
                                                            allowClearing={true}
                                                            deferRendering={true}
                                                            searchEnabled={true}
                                                            wrapItemText={false}
                                                            searchMode={"contains"}
                                                        ></SelectBox>
                                                    ) 
                                                    : 
                                                    (
                                                        <TextBox
                                                            // value={emailSelecionadoState}
                                                            style={{width: '30vw', marginRight: '1em'}}
                                                            onValueChanged={(item) => {
                                                                setEmailSelecionadoState(item.value)
                                                            }}
                                                            
                                                            // mask={@"\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*"}
                                                            mode='email'
                                                            // maskRules={/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+\.([a-z]+)?$/i}
                                                            // maskInvalidMessage='E-mail inválido!'
                                                            // useMaskedValue={true}
                                                            // validationMessageMode='always'
                                                        />
                                                    )
                                                }
                                            </>
                                        ) 
                                        : 
                                            null
                                        }

                                        <div style={{marginRight: '1em'}}>
                                            Telefone:
                                        </div>

                                        {telefonesState?.length > 0 ? 
                                            (
                                                <SelectBox
                                                    style={{width: '20vw'}}
                                                    dataSource={telefonesState}
                                                    defaultValue={telefonesState[0]}
                                                    onValueChanged={(item) => {
                                                        setTelefoneSelecionadoState(item.value)
                                                    }}
                                                    acceptCustomValue={true}
                                                    customItemCreateEvent={"focusout"}
                                                    searchTimeout={200}
                                                    minSearchLength={0}
                                                    showDataBeforeSearch={false}
                                                    showClearButton={true}
                                                    allowClearing={true}
                                                    deferRendering={true}
                                                    searchEnabled={true}
                                                    wrapItemText={false}
                                                    searchMode={"contains"}
                                                    onInput={(e) => {
                                                        const input = e.event?.target
                                                        if(input){
                                                            input.value = input.value.replace(/\D/g, "")
                                                        }
                                                    }}
                                                ></SelectBox>
                                            ) 
                                            : 
                                            (
                                                <TextBox
                                                    // value={emailSelecionadoState}
                                                    style={{width: '20vw'}}
                                                    onValueChanged={(item) => {
                                                        setTelefoneSelecionadoState(item.value)
                                                    }}
                                                    
                                                    // mask={@"\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*"}
                                                    onInput={(e) => {
                                                        const input = e.event?.target
                                                        if(input){
                                                            input.value = input.value.replace(/\D/g, "")
                                                        }
                                                    }}
                                                    // maskInvalidMessage='E-mail inválido!'
                                                    // useMaskedValue={true}
                                                    // validationMessageMode='always'
                                                />
                                            )
                                        }
                                        
                                    
                                    </div>
                                )
                                :
                                null
                                }

                                <Button
                                    text="Enviar e-mail"
                                    // disabled={desabilitarBotoesState ? true : false}
                                    style={{marginLeft: '1em'}}
                                    icon="message"
                                    type="default"
                                    stylingMode="contained"
                                    visible={htmlPermissionsState?.isPermitirEnviarEmail === 1}
                                    onClick={() => {
                                        showLoadPanel()
                                        checkSelectedEmailInEmailsExisting()
                                        //enviar boleto para o email
                                        httpRequest('POST', requestsApi.execProcedureJsonParameter, requestsApi.basicAuth, {
                                            applicationId: applicationID,
                                            relationId: relationId,
                                            procedure: "_enviarTemplateEmail",
                                            json: {
                                                "entityName": props.entityName ? props.entityName : "_titulo",
                                                "codigoTemplate": props.htmlFormPopupDataSourceState,
                                                "email": emailSelecionadoState
                                            },
                                            idValue: [`${props.id}`]
                                        })
                                        .then((sender) => {
                                            hideLoadPanel()
                                            const resultExecProcedureJsonParameterJson = JSON.parse(sender)
                                            toastConfiguration(true, 'success', resultExecProcedureJsonParameterJson?.mensagem)
                                        })
                                        .catch((error) => {
                                            hideLoadPanel()
                                            console.log(error?.data?.error)
                                            setPopupStates({
                                                visible: true,
                                                message: error?.data?.error ? error?.data?.error : 'E-mail inválido!'
                                            })
                                        })
                                    }}
                                />
                                <Button
                                    text="Enviar para assinatura"
                                    // disabled={desabilitarBotoesState ? true : false}
                                    style={{marginLeft: '1em'}}
                                    icon="message"
                                    type="default"
                                    stylingMode="contained"
                                    visible={htmlPermissionsState?.isPermitirEnviarAssinatura === 1}
                                    onClick={() => {
                                        showLoadPanel()
                                        checkSelectedEmailInEmailsExisting()
                                        checkSelectedTelefoneInTelefoneExisting()
                                        //enviar boleto para o email
                                        httpRequest('POST', requestsApi.execProcedureJsonParameter, requestsApi.basicAuth, {
                                            applicationId: applicationID,
                                            relationId: relationId,
                                            procedure: "_enviarTemplateAssinatura",
                                            json: {
                                                "entityName": props.entityName ? props.entityName : "_titulo",
                                                "codigoTemplate": props.htmlFormPopupDataSourceState,
                                                "email": htmlPermissionsState?.isPermitirEnviarEmail === 1 ? emailSelecionadoState : null,
                                                "telefone": telefoneSelecionadoState
                                            },
                                            idValue: [`${props.id}`]
                                        })
                                        .then((sender) => {
                                            hideLoadPanel()
                                            const resultExecProcedureJsonParameterJson = JSON.parse(sender)
                                            toastConfiguration(true, 'success', resultExecProcedureJsonParameterJson?.mensagem)
                                        })
                                        .catch((error) => {
                                            hideLoadPanel()
                                            console.log(error?.data?.error)
                                            setPopupStates({
                                                visible: true,
                                                message: error?.data?.error ? error?.data?.error : 'E-mail inválido!'
                                            })
                                        })
                                    }}
                                />
                            </div>

                        {!editandoHtml &&
                            <div style={{backgroundColor: "white", color: "black"}}>
                                <HtmlComponent/>
                                <iframe 
                                    id="ifmcontentstoprint"
                                    title="ifmcontentstoprint"
                                    scrolling="no"
                                    style={{
                                        height: "200vh",
                                        display: "none",
                                        width: "100%", 
                                        position: "relative",
                                        backgroundColor: "white",
                                        zIndex: -1
                                    }}
                                />
                            </div>
                        }


                        {editandoHtml && 
                            <>
                                <UpfHtmlEditor
                                    dataEntity={htmlContent && htmlContent?.__html}
                                    dataEntityState={htmlContent}
                                    setDataEntity={setHtmlContent}
                                    showEditBar={true}
                                    editandoHtml={editandoHtml}
                                />
                                <iframe 
                                    id="ifmcontentstoprint"
                                    title="ifmcontentstoprint"
                                    scrolling="no"
                                    style={{
                                        height: "200vh",
                                        display: "none",
                                        width: "100%", 
                                        position: "relative",
                                        backgroundColor: "white",
                                        zIndex: -1
                                    }}
                                />
                            </>
                        }
                    </div>
                </ScrollView>
            </Popup>
    )
}

export default HtmlFormPopup;